import { PickupPersonEnum } from '../../lib/types/enums/enrollment/enrollment-pickup'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type EnrollmentPickupPersonInfo = {
  firstName?: string
  lastName?: string
  phoneNumber?: string
}

export function getEnrollmentPickupPersonInfo(id: number, person: PickupPersonEnum) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.enrollments.getEnrollmentPickupPersonInfo.url, { id }),
        { person }
      )
    )
    .get<EnrollmentPickupPersonInfo | null>()
}
